// extracted by mini-css-extract-plugin
module.exports = {"container":"PopdPlaceOrderButton_container__3A7a-","button":"PopdPlaceOrderButton_button__3mjJW","disabled":"PopdPlaceOrderButton_disabled__fyQtH"};